import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightShort } from 'react-bootstrap-icons';

import AllergenList from '../components/allergen/list';
import ArticlesHorizontalList from '../components/article/articles-horizontal-list';
import CalculatorsList from '../components/calculators/calculators-list';
import Framework from '../components/framework';
import Badge from '../components/framework/badges/badge';
import List from '../components/framework/lists/list';
import ListItem from '../components/framework/lists/list-item';
import PageHeader from '../components/framework/pages/page-header';
import SectionHeader from '../components/framework/sections/section-header';
import Slider from '../components/framework/slider';
import MarkerList from '../components/marker/list';
import useTranslation from '../hooks/use_translation';

const FactsPage = ({ location }) => {
	const { t } = useTranslation('facts');

	return (
		<Framework
			description={t('meta_description')}
			location={location}
			tags={t('meta_keywords')}
			title={t('title')}
		>
			<section id="content">
				<div className="container">
					<PageHeader
						className="pb-0"
						excerpt={t('t2')}
						pageVariant="main_page"
						title={t('t1')}
					/>
				</div>
			</section>
			<section className=" pt-0">
				<div className="container">
					<List variant="horizontal">
						<ListItem variant="horizontal">
							<Badge
								icon={<ArrowRightShort />}
								label={t('t11')}
								to="/markorer/"
								type="link"
								variant="primary_light"
								withIcon
							/>
						</ListItem>
						<ListItem variant="horizontal">
							<Badge
								icon={<ArrowRightShort />}
								label={t('t12')}
								to="/allergener/"
								type="link"
								variant="primary_light"
								withIcon
							/>
						</ListItem>
						<ListItem variant="horizontal">
							<Badge
								icon={<ArrowRightShort />}
								label={t('t13')}
								to="/artiklar/"
								type="link"
								variant="primary_light"
								withIcon
							/>
						</ListItem>
						<ListItem variant="horizontal">
							<Badge
								icon={<ArrowRightShort />}
								label={t('t15')}
								to="/symtom/"
								type="link"
								variant="primary_light"
								withIcon
							/>
						</ListItem>
						<ListItem variant="horizontal">
							<Badge
								icon={<ArrowRightShort />}
								label={t('t19')}
								to="/kroppen/"
								type="link"
								variant="primary_light"
								withIcon
							/>
						</ListItem>
						<ListItem variant="horizontal">
							<Badge
								icon={<ArrowRightShort />}
								label={t('t18')}
								to="/kalkylatorer/"
								type="link"
								variant="primary_light"
								withIcon
							/>
						</ListItem>
					</List>
				</div>
			</section>

			<section className=" bg-gray-100 py-3 mt-5" id="facts-articles">
				<div className="container">
					<SectionHeader
						excerpt={t('t14')}
						headingType="h3"
						title={t('t9')}
						to="/artiklar/"
					/>
					<Slider>
						<ArticlesHorizontalList limit={10} />
					</Slider>
				</div>
			</section>
			<section className="section" id="facts-calculators">
				<div className="container">
					<SectionHeader
						excerpt={t('t17')}
						headingType="h3"
						title={t('t16')}
						to="/kalkylatorer/"
					/>
					<CalculatorsList />
				</div>
			</section>
			<section className="section" id="facts-markers">
				<div className="container">
					<SectionHeader
						excerpt={t('t5')}
						headingType="h3"
						title={t('t3')}
						to="/markorer/"
					/>
					<MarkerList col={4} listItemSize="sm" />
				</div>
			</section>
			<section className="section" id="facts-allergens">
				<div className="container">
					<SectionHeader
						excerpt={t('t8')}
						headingType="h3"
						title={t('t6')}
						to="/allergener/"
					/>

					<AllergenList col={4} listItemSize="sm" />
				</div>
			</section>
		</Framework>
	);
};

FactsPage.propTypes = {
	data: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};

export default FactsPage;

export const query = graphql`
	query {
		locales: allLocale {
			...translationFields
		}
	}
`;
